import { Enum } from 'enumify';

class LinksManagementSetLinkStatusEnum extends Enum {
  toJSON() {
    return this.name;
  }
}

LinksManagementSetLinkStatusEnum.initEnum({
  WAITING: 'Waiting',
  PROCESSING: 'Processing',
  ERROR: 'Error',
  SUCCESS: 'Success',
});

export default LinksManagementSetLinkStatusEnum;
